import { mergeObjectTypes } from '../cacheHelpers';

const PortOfLoad = {
  merge: mergeObjectTypes
};

export default PortOfLoad;
